<template>
  <div class="nopads">
      <!-- Header of collapsable item -->
      <div class="col-12 d-flex justify-content-between align-items-center pb-1">
          <div class="flex-grow-1">
              <h4 class="form-header pointer hover-header" @click.stop="inspectionsVisible = !inspectionsVisible">
                  {{ $t('contract_reports.other_inspections') }} ({{ inspections.length }})
              </h4>
          </div>
          <div
              v-if="loading"
              id="loader"
              class="spinner-section"
          />
          <div v-else class="ms-2 px-2" @click.stop="inspectionsVisible = !inspectionsVisible">
              <font-awesome-icon icon="arrow-down" class="pointer no-focus arrow-icon dont-print hover-header" :class="{ rotated:inspectionsVisible }"/>
          </div>
      </div>
      <!-- Collapsable content -->
      <div class="routa-collapse" :class="{ collapsed: inspectionsVisible }">
          <contract-inspections-list :inspections="inspections" class="my-3" @inspection-selected="showInspectionReport"/>
    </div>

    <base-modal
        v-if="inspection"
        size="xl"
        hide-footer
        @close="inspection = null"
    >
      <inspection-report-details
        id="details"
        ref="details"
        :report-details="inspection"
        :is-observer="isObserver"
        :user="user"
        @close="inspection = null"
        @close-and-update="closeAndUpdate"
      />
    </base-modal>
    <hr class="report-divider nopads">
  </div>
</template>

<script>
import {restApi} from "@/components/mixins/RestApiMixin";
import ContractInspectionsList from "@/components/inspections/ContractInspectionsList";
import InspectionReportDetails from "@/components/inspections/InspectionReportDetails.vue";
import BaseModal from "@/components/BaseModal";

export default {
    name: "ContractReportInspections",
    components: {
        BaseModal,
        InspectionReportDetails,
        ContractInspectionsList},
    mixins: [restApi],
    props: {
        searchParams: {
            type: Object,
            default() {
                return null
            }
        },
        isObserver: Boolean,
        user: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            loading: false,
            inspections: [],
            inspection: null,
            inspectionsVisible: false
        }
    },
    watch: {
        searchParams: function () {
            this.fetchInspections()
        }
    },
    mounted() {
        this.fetchInspections()
    },
    methods: {
        fetchInspections: function () {
            if (this.searchParams && this.searchParams.dateTo && this.searchParams.dateFrom && this.searchParams.contract) {
                let params = {
                    from: new Date(this.searchParams.dateFrom).toISOString(),
                    to: new Date(this.searchParams.dateTo).toISOString(),
                    contract: this.searchParams.contract
                }
                this.inspections = []
                this.loading = true
                this.$emit('loading', true)
                this.restFetchParams(this.inspectionReportGenericUrl, params, this.handleResponse, this.handleFail)
            }
        },
        handleResponse: function (response) {
            this.loading = false
            this.$emit('loading', false)
            this.inspections = response.data
        },
        handleFail: function () {
            this.loading = false
            this.$emit('loading', false)
        },
        showInspectionReport(item) {
            this.inspection = item
        },
        closeAndUpdate() {
            this.inspection = null
            this.inspectionsVisible = false
            this.fetchInspections()
        }
    }
}
</script>
